import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

export const ClickUpIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <path
      d="M1.77197 15.3115L4.7859 13.0027C6.38716 15.0926 8.08843 16.0558 9.9821 16.0558C11.8656 16.0558 13.5188 15.104 15.0479 13.0305L18.1049 15.2837C15.8986 18.2736 13.1568 19.8533 9.9821 19.8533C6.81754 19.8533 4.04919 18.2837 1.77197 15.3115Z"
      fill="url(#paint0_linear_24530_73503)"
    />
    <path
      d="M9.97175 5.27596L4.60719 9.89874L2.12744 7.02279L9.98314 0.253174L17.7768 7.02786L15.2857 9.89368L9.97175 5.27596Z"
      fill="url(#paint1_linear_24530_73503)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_24530_73503"
        x1="1.77197"
        y1="17.6618"
        x2="18.1049"
        y2="17.6618"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8930FD" />
        <stop offset="1" stopColor="#49CCF9" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_24530_73503"
        x1="2.12744"
        y1="6.81313"
        x2="17.7768"
        y2="6.81313"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF02F0" />
        <stop offset="1" stopColor="#FFC800" />
      </linearGradient>
    </defs>
  </SvgIcon>
);
